/** Redux Reducers. */
import {
    setFormData as setFormDataOim,
    resetFormData as resetFormDataOim,
    addHBL as addHBLOim,
    updateHBLtitle as UpdateHBLtitleOim,
    updateHBL as updateHBLOim,
    deleteHBL as deleteHBLOim,
    addContainer as addContainerOim,
    updateContainer as updateContainerOim,
    deleteContainer as deleteContainerOim,
} from 'shared/store/slices/oim-newShipmentSlice';
import {
    setFormData as setFormDataOex,
    resetFormData as resetFormDataOex,
    addHBL as addHBLOex,
    updateHBLtitle as UpdateHBLtitleOex,
    updateHBL as updateHBLOex,
    deleteHBL as deleteHBLOex,
    addContainer as addContainerOex,
    updateContainer as updateContainerOex,
    deleteContainer as deleteContainerOex,
} from 'shared/store/slices/oex-newShipmentSlice';
import {
    setFormData as setFormDataAim,
    resetFormData as resetFormDataAim,
    addHAWB as addHAWBAim,
    updateHAWBtitle as updateHAWBtitleAim,
    updateHAWB as updateHAWBAim,
    deleteHAWB as deleteHAWBAim,
    addAlias as addAliasAim,
    updateAlias as updateAliasAim,
    deleteAlias as deleteAliasAim,
} from 'shared/store/slices/aim-newShipmentSlice';
import {
    setFormData as setFormDataAex,
    resetFormData as resetFormDataAex,
    addHAWB as addHAWBAex,
    updateHAWBtitle as updateHAWBtitleAex,
    updateHAWB as updateHAWBAex,
    deleteHAWB as deleteHAWBAex,
    addAlias as addAliasAex,
    updateAlias as updateAliasAex,
    deleteAlias as deleteAliasAex,
} from 'shared/store/slices/aex-newShipmentSlice';
import {
    setFormData as setFormDataTrucking,
    resetFormData as resetFormDataTrucking,
    addAlias as addAliasTrucking,
    updateAlias as updateAliasTrucking,
    deleteAlias as deleteAliasTrucking,
} from 'shared/store/slices/trucking-newShipmentSlice';

export const actionMap = {
    // Ocean Import
    setFormDataOim,
    resetFormDataOim,
    addContainerOim,
    updateContainerOim,
    deleteContainerOim,
    addHBLOim,
    UpdateHBLtitleOim,
    updateHBLOim,
    deleteHBLOim,

    // Ocean Export
    setFormDataOex,
    resetFormDataOex,
    addContainerOex,
    updateContainerOex,
    deleteContainerOex,
    addHBLOex,
    UpdateHBLtitleOex,
    updateHBLOex,
    deleteHBLOex,

    // Air Import
    setFormDataAim,
    resetFormDataAim,
    addAliasAim,
    updateAliasAim,
    deleteAliasAim,
    addHAWBAim,
    updateHAWBtitleAim,
    updateHAWBAim,
    deleteHAWBAim,

    // Air Export
    setFormDataAex,
    resetFormDataAex,
    addAliasAex,
    updateAliasAex,
    deleteAliasAex,
    addHAWBAex,
    updateHAWBtitleAex,
    updateHAWBAex,
    deleteHAWBAex,

    // Trucking
    setFormDataTrucking,
    resetFormDataTrucking,
    addAliasTrucking,
    updateAliasTrucking,
    deleteAliasTrucking,
};
